import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';

var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
/**
 * Returns a stateful value, and a function to update it. Mimics the `useState()` React Hook
 * signature.
 */


var useAutoControlled = function useAutoControlled(options) {
  var defaultValue = options.defaultValue,
      _options$initialValue = options.initialValue,
      initialValue = _options$initialValue === void 0 ? undefined : _options$initialValue,
      value = options.value;

  var _React$useState = React.useState(isUndefined(defaultValue) ? initialValue : defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  return [isUndefined(value) ? state : value, setState];
};

export default useAutoControlled;